<template>
  <div class="form form--vertical">
    <input
      class="form__textfield"
      type="text"
      name="email"
      v-model="email"
      @keyup.enter="login(email, password)"
      @keypress="checkCaps"
      @keydown="capsLockToggle"
    />
    <div
      class="caps-warning"
      v-show="capsLockEnabled"
      v-text="locales.common && locales.common.capsWarning"
    ></div>
    <div style="position: relative; margin-top: 10px">
      <input
        class="form__textfield"
        type="password"
        name="password"
        v-model="password"
        @keyup.enter="login(email, password)"
        @keypress="checkCaps"
        @keydown="capsLockToggle"
      />
      <i
        class="fa fa-eye-slash"
        id="togglePassword"
        style="right: 10px; cursor: pointer; position: absolute; top: 9px"
        @click="togglePassword"
        :title="locales && locales.common && locales.common.show_password"
      ></i>
    </div>
    <div
      class="caps-warning"
      v-show="capsLockEnabled"
      v-text="locales.common && locales.common.capsWarning"
    ></div>
    <button class="form__button" @click="login(email, password)">Login</button>
    <a href="/redirect" class="form__button form__button--login-with-facebook">
      <i class="fa fa-facebook" aria-hidden="true"></i>
      <span>Login with Facebook</span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      email: null,
      password: null,
      capsLockEnabled: null,
      isTouchDevice: false,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
  },
  methods: {
    checkTouchDevice() {
      var md = new MobileDetect(window.navigator.userAgent);
      if (
        (md.mobile() !== "" && md.mobile() !== null) ||
        (md.tablet() !== "" && md.tablet() !== null)
      ) {
        this.isTouchDevice = true;
      }
    },
    capsLockToggle(e) {
      if (this.isTouchDevice) return;
      if (e.keyCode == 20 && this.capsLockEnabled !== null) {
        this.capsLockEnabled = !this.capsLockEnabled;
      }
    },
    getChar(e) {
      if (e.which == null) {
        return String.fromCharCode(e.keyCode); // IE
      }
      if (e.which != 0 && e.charCode != 0) {
        return String.fromCharCode(e.which); // rest
      }
      return null;
    },
    checkCaps(e) {
      if (this.isTouchDevice) return;
      var chr = this.getChar(e);
      if (!chr) return;
      if (chr.toLowerCase() == chr.toUpperCase()) return;
      this.capsLockEnabled =
        (chr.toLowerCase() == chr && e.shiftKey) ||
        (chr.toUpperCase() == chr && !e.shiftKey);
    },
    login(email, password) {
      this.$store.dispatch("authLogin", { email, password });
    },
    togglePassword() {
      var togglePassword = $("#togglePassword");
      var password = togglePassword.parent().find("[name='password']").first();
      // toggle the type attribute
      var type = password.attr("type") === "password" ? "text" : "password";
      password.attr("type", type);
      // toggle the eye / eye slash icon
      togglePassword.toggleClass("fa-eye");
      togglePassword.toggleClass("fa-eye-slash");
    },
  },
  mounted() {
    this.checkTouchDevice();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Login.vue